export default __webpack_public_path__ + "static/media/hht1_direction_quiztime_02.2077655a.png";